import React, { useEffect, useState } from "react";
import { login } from "../../services/userServices";
import { useTranslation } from "react-i18next";
import jwt_decode from "jwt-decode";
import { getCompanyUniqueKey, getLogoPath } from "../../helpers/utils";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { notification } from "../../helpers/notification";

export const LoginContainer = () => {
  const [loginState, setState] = useState({
    username: "",
    password: "",
  });
  const [recaptchaStatus, setRecaptchaStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const submit = () => {
    setIsLoading(true);
    login({
      email: loginState.username,
      password: loginState.password,
      companyUniqueKey: getCompanyUniqueKey(),
    })
      .then((response) => {
        notification.success({ message: "Giriş İşlemi Başarılı" });
        window.localStorage.setItem("eventsafeguardtoken", response.token);
        window.localStorage.setItem("user", response.claims.usercode);
        window.localStorage.setItem("fullname", response.claims.fullName);
        window.localStorage.setItem("companyname", response.claims.companyName);
        window.localStorage.setItem(
          "companyUniqueKey",
          response.claims.companyUniqueKey
        );
        const encodedJwt = jwt_decode(response.token);
        window.location = encodedJwt.isSupplier ? "/supplier-events" : "/";
        setIsLoading(false);
      })
      .catch((response) => {
        let message = "Bir Hata Oluştu Tekrar Deneyiniz.";
        if (response) message = t(response.data.message);
        notification.error({ message });
        setIsLoading(false);
      });
  };

  const onChangeHandler = (e) => {
    setState({ ...loginState, [e.target.name]: e.target.value });
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Lc_MKIdAAAAACKslmEJAHj9aTZ_elgNZZmyxbs3"
    >
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950 px-4">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src={getLogoPath()}
              alt="Logo"
              className="h-12 mx-auto dark:hidden"
            />
          </div>

          {/* Card */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 p-8">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Giriş Yap
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                Etkinlik Personel Yönetimi
              </p>
            </div>

            <div className="space-y-4">
              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                  E-Posta Adresiniz
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                    </svg>
                  </div>
                  <input
                    type="email"
                    name="username"
                    value={loginState.username}
                    onChange={onChangeHandler}
                    placeholder="ornek@email.com"
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm placeholder-gray-400 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all"
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                  Şifreniz
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                    </svg>
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={loginState.password}
                    onChange={onChangeHandler}
                    placeholder="••••••••"
                    onKeyDown={(e) => e.key === "Enter" && submit()}
                    className="w-full pl-10 pr-12 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm placeholder-gray-400 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  >
                    {showPassword ? (
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Login Button */}
              <button
                onClick={submit}
                disabled={!recaptchaStatus || isLoading}
                className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-brand-500 hover:bg-brand-600 disabled:bg-gray-300 dark:disabled:bg-gray-700 text-white font-medium text-sm rounded-lg transition-colors mt-2"
              >
                {isLoading ? (
                  <>
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    <span>Lütfen Bekleyiniz</span>
                  </>
                ) : (
                  <span>Giriş Yap</span>
                )}
              </button>
            </div>

            {/* Divider */}
            <div className="flex items-center gap-4 my-6">
              <div className="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
              <span className="text-xs text-gray-400 uppercase">veya</span>
              <div className="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
            </div>

            {/* Chef Login Link */}
            <a
              href="/chef-login"
              className="block w-full text-center py-2.5 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 font-medium text-sm rounded-lg transition-colors"
            >
              Amir Olarak Giriş Yap
            </a>
          </div>

          <GoogleReCaptcha
            onVerify={() => setRecaptchaStatus(true)}
          />
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};
